import { useCallback, useContext } from 'react';
import Cards from 'src/components/Cards';
import { EditCellContext } from 'src/contexts/EditCellContext';

import { GridCellProps } from '@progress/kendo-react-grid';
import useBoolean from 'src/hooks/useBoolean';
import useRedirectBtn from 'src/hooks/useRedirectBtn';
import GridCellBase from '../../../components/GridCellBase';
import Button from '../../../components/design-system/Button';
import PopUp from '../../../components/design-system/PopUp';

const InformationComponent = () => (
  <Cards title="Information" styleType="information">
    <ul>
      <li style={{ wordWrap: 'break-word' }}>
        There may be a pending transmission, and a duplicate record may be created.
      </li>
    </ul>
  </Cards>
);

const CreateNewDoc = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { onCreateNewClick, openNewTab = true } = cellClick?.(null);
  const RedirectButton = useRedirectBtn(true, openNewTab);

  const { value: isLoading, setTrue: startLoading, setFalse: endLoading } = useBoolean();

  const handleCreateNewClick = useCallback(async () => {
    startLoading();
    await onCreateNewClick(props.dataItem);
    endLoading();
  }, [endLoading, onCreateNewClick, props.dataItem, startLoading]);

  if (props.dataItem.receiptId === null) {
    return (
      <GridCellBase {...props} rowSelectionEnabled={false} className="flex justify-center">
        <PopUp
          content={props.dataItem.is810Enabled ? <InformationComponent /> : null}
          show={props.dataItem.is810Enabled}
        >
          <Button color="secondary" onClick={handleCreateNewClick} loading={isLoading}>
            Create New
          </Button>
        </PopUp>
      </GridCellBase>
    );
  }

  return <RedirectButton {...props} />;
};

export default CreateNewDoc;
